import React from 'react'
import { MdPix } from 'react-icons/md'

import './stylesBttPix.css'

export default function Button({ onClick, text }) {
  return (
    <button className='btt-contain-ver-pix' onClick={onClick}>
      <h2>{text}</h2>
      <MdPix
        //Cor do PIX
        className='btt-icon-pix'
        size={30}
      />
    </button>
  )
}
